import { ROUND_ENROLMENTS_OVERVIEW_TAB_STATES } from './reducer'

export const rewriteFilter = (
  originalFilter: {
    [key: string]: string;
  },
) => {
  if(JSON.stringify(originalFilter.status) !== JSON.stringify(ROUND_ENROLMENTS_OVERVIEW_TAB_STATES.late)) {
    return originalFilter
  }

  const newFilter = {...originalFilter} as const

// @ts-expect-error - TS2542 - Index signature in type '{ readonly [x: string]: string; }' only permits reading.
  delete newFilter.status
// @ts-expect-error - TS2322 - Type 'boolean' is not assignable to type 'string'. | TS2542 - Index signature in type '{ readonly [x: string]: string; }' only permits reading.
  newFilter.lateSubmission = true

  return newFilter
}
